import React from 'react';
import { Box, Card, Grid, Typography, Button, styled } from '@mui/material';
import BackgroundImage from '../components/BackgroundImage';
import Marquee from 'react-fast-marquee';
import back1 from '../images/tm.jpg';
import back2 from '../images/whiteBack.jpg';
import bloommark from '../images/bloommark.png';
import menuLogo from '../images/Menu.png';
import theliElla from '../images/Theli Ella.png';
import sucess from '../images/success.jfif';
import {
  Devices,
  PhoneIphone,
  Cloud,
  DesktopMac,
  ShoppingCart,
  Brush,
  Palette,
  Web
} from '@mui/icons-material';

// Styled components for a cleaner, more modern look
const SectionBox = styled(Box)(({ theme }) => ({
    width: '90%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
        width: '95%',
    },
}));

const StyledCard = styled(Card)(({ theme }) => ({
    height: '100%',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: theme.shape.borderRadius * 2,
    transition: 'transform 0.3s, box-shadow 0.3s',
    '&:hover': {
        transform: 'translateY(-10px)',
        boxShadow: theme.shadows[8],
    },
}));

// We'll use MUI's built-in icons directly instead of images
const StyledIcon = styled(Box)(({ theme }) => ({
    color: theme.palette.primary.main, // Use the primary color from your theme
    fontSize: '55px', // Adjust size as needed
    marginBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const ClientLogo = styled('img')({
    height: '60px',
    margin: '0 2rem',
    filter: 'grayscale(100%)',
    transition: 'filter 0.3s',
    '&:hover': {
        filter: 'grayscale(0%)',
    },
});

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    borderRadius: '50px',
    backgroundColor: '#fff',
    color: '#000',
    fontWeight: 'bold',
    textTransform: 'none',
    boxShadow: theme.shadows[3],
    transition: 'background-color 0.3s, transform 0.3s, color 0.3s', // Added 'color 0.3s'
    '&:hover': {
        backgroundColor: '#a974d0', // Changed hover background color
        color: '#fff', // Added hover text color
        transform: 'translateY(-2px)',
    },
}));



function Home() {
    return (
        <>
            <BackgroundImage />
            <Box sx={{ py: 8 }}>
                <SectionBox>
                    <center>
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'text.secondary',
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: '500',
                                letterSpacing: '2px',
                            }}
                        >
                            ALL BUSINESS REQUIREMENTS UNDER ONE ROOF
                        </Typography>
                        <Typography
                            variant="h3"
                            component="h1"
                            sx={{
                                color: 'text.primary',
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: 'bold',
                                mt: 1,
                                mb: 5,
                            }}
                        >
                            From Product Design To Software Development
                        </Typography>
                    </center>
                    <Grid container spacing={4}>
                        {/* New service cards with MUI icons */}
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><Web fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    Website Development
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Crafting beautiful and responsive websites to establish your online presence.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><Cloud fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    Web Application
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Building innovative web applications to support and scale your business operations.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><DesktopMac fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    Desktop Application
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Creating powerful, cross-platform desktop software to streamline your workflow.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><PhoneIphone fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    Mobile Application
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Developing high-quality, native and cross-platform mobile apps for iOS and Android.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><Devices fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    Digital Marketing
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Innovative strategies to grow your brand, reach new customers, and drive sales.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><Brush fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    Graphic Designing
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Professional and creative design services to visually communicate your brand identity.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><Palette fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    UI/UX Design
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Creating intuitive and engaging user experiences from wireframing to final design.
                                </Typography>
                            </StyledCard>
                        </Grid>
                        <Grid item md={4} sm={6} xs={12}>
                            <StyledCard>
                                <StyledIcon><ShoppingCart fontSize="inherit" /></StyledIcon>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
                                    POS Systems
                                </Typography>
                                <Typography sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}>
                                    Specialized in developing custom Point of Sale systems to simplify your retail operations.
                                </Typography>
                            </StyledCard>
                        </Grid>
                    </Grid>
                </SectionBox>
            </Box>

            {/* How we manage section */}
            <Box sx={{ py: 8, backgroundColor: '#f9f9f9' }}>
                <SectionBox>
                    <center>
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'text.secondary',
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: '500',
                                letterSpacing: '2px',
                            }}
                        >
                            BUILD YOUR DREAM INTO REALITY
                        </Typography>
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                color: 'text.primary',
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: 'bold',
                                mt: 1,
                                mb: 5,
                            }}
                        >
                            How We Manage Your Aspiring Projects
                        </Typography>
                    </center>
                    <Grid container spacing={6} alignItems="center">
                        <Grid item md={5} xs={12}>
                            <Box
                                component="img"
                                src={sucess}
                                alt="success"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: '16px',
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                        <Grid item md={7} xs={12}>
                            <Box>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 1 }}>
                                    Organizing Your Business Needs
                                </Typography>
                                <Typography sx={{ color: 'text.secondary', mb: 3 }}>
                                    We are attentive to every possible detail about your business, and we analyze it carefully to understand your business requirements to deliver the best result.
                                </Typography>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 1 }}>
                                    Conducting Tests & Overseeing
                                </Typography>
                                <Typography sx={{ color: 'text.secondary', mb: 3 }}>
                                    We run multiple tests to assure the product’s quality and keep an informed report to measure the progress.
                                </Typography>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'text.primary', mb: 1 }}>
                                    Ready To Go Live
                                </Typography>
                                <Typography sx={{ color: 'text.secondary' }}>
                                    Since the launch of your project, we constantly check for any bugs or issues and provide services and maintenance to make sure the project works smoothly.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </SectionBox>
            </Box>

            {/* Clients section */}
            <Box
                sx={{
                    py: 8,
                    backgroundImage: `url(${back2})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                }}
            >
                <SectionBox>
                    <center>
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                color: 'text.primary',
                                fontWeight: 'bold',
                                mb: 2,
                            }}
                        >
                            Our Truly Amazing Clients
                        </Typography>
                        <Typography
                            sx={{
                                color: 'text.secondary',
                                mb: 5,
                                maxWidth: '800px',
                                mx: 'auto',
                            }}
                        >
                            CC Software Solutions is proud to be associated with esteemed and prestigious clientele.
                            We promise to best represent our clients and exceed their expectations in every way possible.
                            Our top priority is meeting all the requirements of our amazing clients, who motivate us everyday.
                        </Typography>
                    </center>
                    <Marquee gradient={false} speed={50}>
                        <ClientLogo src={menuLogo} alt="Menu Logo" />
                        <ClientLogo src={bloommark} alt="Bloommark Logo" />
                        <ClientLogo src={theliElla} alt="Theli Ella Logo" />
                        <ClientLogo src={menuLogo} alt="Menu Logo" />
                        <ClientLogo src={bloommark} alt="Bloommark Logo" />
                        <ClientLogo src={theliElla} alt="Theli Ella Logo" />
                    </Marquee>
                </SectionBox>
            </Box>

            {/* Contact section */}
            <Box
                sx={{
                    height: '35vh',
                    backgroundImage: `url(${back1})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    color: '#fff',
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: '500',
                            fontSize: { md: '6rem', xs: '4rem' },
                        }}
                    >
                        Let's Start
                    </Typography>
                    <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontFamily: 'Montserrat, sans-serif',
                                                        fontWeight: '700',
                                                        fontSize: { md: '1.25rem', xs: '1rem' },
                                                        mt: 2
                                                    }}
                                                    >
                                                    Empowering businesses through custom software solutions.{' '}
                                                    <span style={{ color: '#a974d0' }}>Your success, our code.</span>
                                                </Typography>
                    <StyledButton href="/contactus">Get In Touch</StyledButton>
                </Box>
            </Box>
        </>
    );
}

export default Home; 